import { ReportTypeEnum } from "@api/rest/types-and-hooks";
import {
  GoalFieldIdentifier,
  TPFieldType,
  type TPFieldTypeValue,
  TargetFieldIdentifier,
} from "@pages/Templates/constants";

const PROGRESS_SUMMARY_IDENTIFIER: Record<TPFieldTypeValue, string> = {
  [TPFieldType.GOAL]: GoalFieldIdentifier.PROGRESS_SUMMARY,
  [TPFieldType.TARGET]: TargetFieldIdentifier.PROGRESS_SUMMARY,
};

interface ProgressSummaryCandidate {
  type: TPFieldTypeValue;
  field_identifier: string;
}

interface MissingProgressSummaryInput {
  reportType: string;
  isGasEnabled: boolean;
  isAddTargetsEnabled: boolean;
  fields: readonly ProgressSummaryCandidate[];
}

/** Field types (GOAL/TARGET) whose Progress Summary field is missing on a
 * reassessment template that should have it. Reassessments only show a
 * saved progress summary when the template lists the native field, which
 * is keyed by field identifier, so only an exact `progress_summary` key
 * counts. A disabled row is a deliberate choice and doesn't count as
 * missing. GAS templates use the goal attainment scale fields instead, and
 * the target field only applies when adding targets is enabled. */
export function missingProgressSummaryTypes({
  reportType,
  isGasEnabled,
  isAddTargetsEnabled,
  fields,
}: MissingProgressSummaryInput): TPFieldTypeValue[] {
  if (reportType !== ReportTypeEnum.REASSESSMENT || isGasEnabled) return [];
  const required: TPFieldTypeValue[] = isAddTargetsEnabled
    ? [TPFieldType.GOAL, TPFieldType.TARGET]
    : [TPFieldType.GOAL];
  return required.filter(
    (type) => !fields.some((f) => f.type === type && f.field_identifier.trim() === PROGRESS_SUMMARY_IDENTIFIER[type]),
  );
}
